import { BeforeSendFunction, AfterSendFunction, SendRequestFunction } from './jsFormTypes';

type BeforeSend = {
    [key: string]: BeforeSendFunction
}
type AfterSend<T> = {
    [key: string]: AfterSendFunction<T>
}

type SendRequest<T> = {
    [key: string]: SendRequestFunction<T>
}

export class FormHandlers {
    private static beforeSendHandlers: BeforeSend = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static afterSendHandlers: AfterSend<any> = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static sendRequestHandlers: SendRequest<any> = {};

    public static registerBeforeSendHandler(name: string, handler: BeforeSendFunction): void {
        FormHandlers.beforeSendHandlers[name] = handler;
    }

    public static registerAfterSendHandler<T>(name: string, handler: AfterSendFunction<T>) {
        FormHandlers.afterSendHandlers[name] = handler;
    }

    public static registerSendRequestHandler<T>(name: string, handler: SendRequestFunction<T>) {
        FormHandlers.sendRequestHandlers[name] = handler;
    }

    public static getBeforeSendHandler(name: string): BeforeSendFunction {
        // @ts-ignore
        return FormHandlers.beforeSendHandlers[name] || window.app[name];
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getAfterSendHandler(name: string): AfterSendFunction<any> {
        // @ts-ignore
        return FormHandlers.afterSendHandlers[name] || window.app[name];
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getSendRequestHandler(name: string): SendRequestFunction<any> {
        // @ts-ignore
        return FormHandlers.sendRequestHandlers[name] || window.app[name];
    }
}
